/**
 * Escapes special characters in the provided string, making it suitable for
 * use in RegExp().
 *
 * Adapted from MDN's regular expressions guide.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping}
 * @param {string} str The string to escape.
 * @returns {string} The escaped string.
 */
export function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Checks if the provided value is a plain object.
 *
 * @param {*} obj The value to check.
 * @returns {boolean} Whether or not the value is a plain object.
 */
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

/**
 * Checks if the user has indicated a preference for reduced motion.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion}
 * @returns {boolean}
 */
export const prefersReducedMotion = (() => {
  const media =
    "matchMedia" in window ? window.matchMedia("prefers-reduced-motion") : { matches: false };
  return () => media.matches;
})();

/**
 * Generates a unique id optionally prefixed with the provided string
 *
 * @param {string|undefined} prefix Optional. The id prefix.
 * @returns {string} A unique id.
 */
export const uniqueId = (() => {
  let index = 0;
  return (prefix = "id-") => {
    let id;
    while (!id || document.getElementById(id)) {
      id = `${prefix}${++index}`;
    }
    return id;
  };
})();
